import styled from 'styled-components';

import { useValue } from '@components/component-helpers';
import { IconCloseRegular } from '@components/icons/close-regular';
import { IconSearch } from '@components/icons/search';
import { TextField, TextFieldProps } from '@components/text-field';
import { theme } from '@styles/theme';
import { transitionSlow } from '@utils/transitions';

type TextFieldBase = Omit<TextFieldProps, 'label' | 'hideLabel' | 'iconLeft' | 'iconRight'>;
export type SearchBoxProps = TextFieldBase & {};

export const SearchBox = ({
  onChange: userOnChange = () => null,
  onChangeDebounce,
  defaultValue = '',
  dataTestid,
  value: controlledValue,
  ...rest
}: SearchBoxProps) => {
  const { onChange, value } = useValue({
    defaultValue,
    onChange: userOnChange,
    onChangeDebounce,
  });
  const finalValue = controlledValue ?? value;
  const hasValue = finalValue !== '';

  return (
    <SearchBoxContainer
      className="search-box-container"
      data-hasvalue={hasValue}
      data-testid={dataTestid}
    >
      <TextField
        label="Search"
        hideLabel
        onChange={onChange}
        value={finalValue}
        iconLeft={
          <span className="search-box-left-icon">
            <IconSearch />
          </span>
        }
        iconRight={
          <IconCloseRegular
            className="text-clear-icon"
            onClick={(e) => {
              e.stopPropagation();
              onChange('');
            }}
            style={{ opacity: hasValue ? 1 : 0, transition: transitionSlow('opacity') }}
          />
        }
        dataTestid="search-box-input-field"
        {...rest}
      />
    </SearchBoxContainer>
  );
};

const SearchBoxContainer = styled.div({
  '.search-box-left-icon': {
    display: 'flex',
  },

  '&[data-hasvalue="true"]': {
    '.search-box-left-icon': {
      '--icon-color': theme.color.elementBlue100,
    },
  },
});
